// src/hooks/useFCM.js
import { useEffect } from 'react';
import { messaging, db, auth } from '../firebase';
import { getToken, onMessage } from 'firebase/messaging';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

export const useFCM = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const setupFCM = async () => {
      const user = auth.currentUser;
      if (!user) return;

      try {
        // 1. Request Permission & Get Token
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          const currentToken = await getToken(messaging, { 
            vapidKey: 'BEFt0PLvPA9Qcu8ZL8fkxRy_HZe5rnmsZsYlKfzFVgm8R5AMaGU_ffpJ5omPF_WM6XCpcmexlRlOP1y-DyO8MPE' // <--- PASTE VAPID KEY HERE
          });

          if (currentToken) {
            // 2. Save token to Firestore so Cloud Function can find it
            const tokenRef = doc(db, 'users', user.uid, 'tokens', currentToken);
            await setDoc(tokenRef, {
              platform: 'web',
              createdAt: serverTimestamp(),
            });
            console.log("FCM Token saved successfully.");
          }
        }
      } catch (error) {
        console.error('FCM Token Error:', error);
      }
    };

    // Run setup if user is logged in
    const unsubscribeAuth = auth.onAuthStateChanged(user => {
      if (user) setupFCM();
    });

    // 3. Handle FOREGROUND Messages (When the user has the website open)
    const unsubscribeMessage = onMessage(messaging, (payload) => {
      console.log('Foreground Message received. ', payload);
      
      const { title, body } = payload.notification;
      const { chatRoomId } = payload.data;

      // Create a native browser notification (or you could use a custom HTML toast here)
      if (Notification.permission === 'granted') {
        const notification = new Notification(title, {
          body: body,
          icon: '/logo192.png'
        });

        // 4. Handle onTap for the foreground notification
        notification.onclick = () => {
          window.focus();
          if (chatRoomId) {
            // We use navigate to go to the chat screen
            navigate('/chat', { state: { targetRoomId: chatRoomId } });
          }
          notification.close();
        };
      }
    });

    return () => {
      unsubscribeAuth();
      unsubscribeMessage();
    };
  }, [navigate]);
};